<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <div class="posting-container">
        <mat-icon class="close-dialog" (click)="dialogRef.close(false)">close</mat-icon>
        <div class="layer"></div>
        <div class="posting-image" *ngIf="postingResource.image" [style.background-image]="'url(' + postingResource.image.url + ')'"></div>
        <div class="posting-title" fxLayout="column" fxLayoutAlign="center center">
            <mat-chip-set class="mb-4" tabIndex="-1" *ngIf="postingResource.postingType.displayNameKeySingular">
                <mat-chip class="accent-500" [disableRipple]="true">{{ postingResource.postingType.displayNameKeySingular | translate }}</mat-chip>
            </mat-chip-set>
            <h2 tabIndex="0" class="text-center">{{ postingResource.translation.title }}</h2>
        </div>
    </div>
    <div class="posting-content p-16 p-sm-40">
        <p [innerHTML]="postingResource.translation.description | safeHtml"></p>
    </div>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center" class="pt-24 mb-0 action-buttons" *ngIf="postingResource.url">
    <app-flat-button [label]="postingResource.postingType.actionButtonTextKey" (onClick)="openPostingUrl()"></app-flat-button>
</div>
